import React from 'react';
import withData from '../../../../core/containers/withData';
import Box from '../../../../components/Box';
import Spinner from '../../../../components/Spinner';
import { buildStatsRow } from '../../../../utils';
import { filter, orderBy } from 'lodash';
import './BestWorst.css';

class BestWorst extends React.Component {
  getPlayersBestWorst(data, sortBy, sortOrder, filterBy) {
    const filtered = filter(filterBy ? filter(data, filterBy) : data, row => !row.released); // filter released players
    const sorted = orderBy(filtered, [sortBy], [sortOrder])
      .slice(0, 5).map(row => ({
        ...row,
        name: `${row.last_name} ${row.first_name ? row.first_name[0] + '.' : ''}`
      }));

    return sorted;
  }

  renderColumns() {
    const { data } = this.props;

    if (!data || !data.length) {
      return null;
    }

    data.map(row => {
      return buildStatsRow(row);
    });

    let columns = [];

    [
      { metric: 'points', sortOrder: 'desc' },
      { metric: 'p3_percent', sortOrder: 'desc', filterBy: row => row.p3_attempts > 1 },
      { metric: 'ft_percent', sortOrder: 'asc', filterBy: row => row.ft_attempts > 1 },
      { metric: 'of_rebounds', sortOrder: 'desc' },
      { metric: 'assists', sortOrder: 'desc' },
      { metric: 'steals', sortOrder: 'desc' },
      { metric: 'turnovers', sortOrder: 'desc' }
    ].map(item => {
      const bestWorst = this.getPlayersBestWorst(data, item.metric, item.sortOrder, item.filterBy);
      return columns.push(
        <td key={ item.metric }>
          <table className="table table-bordered table-hover table-stats table-stats-inner">
          <tbody>
            {
              bestWorst.map((row, i) => (
                <tr key={ i }>
                  <td>{ row.name }</td>
                  <td>{ row[item.metric].toFixed(1) }</td>
                </tr>
              ))
            }
          </tbody>
          </table>
        </td>
      );
    });

    return <tr>{ columns }</tr>;
  }

  render() {
    const { last, combined, isFetching } = this.props;

    return (
      <Box title={ `${last === true ? 'All' : 'Last ' + last} Games Best/Worst Performance ${combined ? '(combined)': ''}` }
           className="table-responsive">
        { isFetching && <Spinner /> }
        <table className="table table-bordered table-stats">
        <tbody>
          <tr>
            <th>Best Scorers</th>
            <th>Best 3P%</th>
            <th>Worst FT%</th>
            <th>Best OR</th>
            <th>Best AS</th>
            <th>Best ST</th>
            <th>Worst TO</th>
          </tr>
          { this.renderColumns() }
        </tbody>
        </table>
      </Box>
    );
  }
};

export default withData(BestWorst);



// WEBPACK FOOTER //
// ./src/features/scout-report/components/BestWorst/BestWorst.js